/**
 * Retorna o nome da carteira selecionada. Utiliza o apelido da carteira caso exista
 *
 * @param carteiraList Lista com todas as carteiras
 * @param carteiraSelecionada Carteira atual
 * @returns Nome da carteira
 */
export function useDisplayCarteira(carteiraList, carteiraSelecionada) {
    var _a;
    if (!carteiraSelecionada)
        return '';
    const aliasCart = (_a = carteiraList.find((x) => x.nome_portfolio === carteiraSelecionada)) === null || _a === void 0 ? void 0 : _a.alias_nome_portfolio;
    return aliasCart !== null && aliasCart !== void 0 ? aliasCart : carteiraSelecionada;
}
export default useDisplayCarteira;
